<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
        <v-flex xs5>
            <v-text-field v-model="title" label="title"></v-text-field>
        </v-flex>     
        <v-flex xs5>
            <v-text-field v-model="content" label="content"></v-text-field>
        </v-flex>     
        <v-flex xs2>
            <v-btn color="success" @click="post">post</v-btn>
        </v-flex>      
    </v-layout>
    <v-data-iterator
      :items="items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      content-tag="v-layout"
      row
      wrap
    >
      <template v-slot:item="props">
        <v-flex xs12 sm6 md4 lg3>
          <v-card>
            <v-card-title><h4>{{ props.item.title }}</h4></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                {{ props.item.content }}
            </v-card-text>
            <v-card-text>
                {{ props.item.id }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="put(props.item.id)">put</v-btn>
                <v-btn @click="del(props.item.id)">del</v-btn>                
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </v-container>
</template>
<script>
  export default {
    data: () => ({
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      items: [],
      title: '',
      content: ''
    }),
    // mounted : 페이지가 그려진 후 실행되는 라이프사이클 메소드
    mounted(){
      this.get()
    },
    methods:{
        // CRUD
        // post 글쓰기, get읽기, put수정, del 삭제
        // async 와 await를 이용해서 비동기적으로 데이터가 CRUD 작업이 이루어진 후 다시 get() read 할 수 있도록 설정한다.
        async post (){
            // this.items.push({
            //     title : this.title,
            //     content : this.content
            // })
            
            // firestore에 데이터 insert
            const r = await this.$firebase.firestore().collection('notes').add({ title : this.title, content : this.content })
            this.title= ''
            this.content= ''
            this.get()
            console.log(r)
        },
        async get (){
         // const r = await this.$firebase.firestore().collection('notes').get() //전체조회
          this.items = [] // 초기화를 반드시 해야함 왜 ??

          // this.$firebase.firestore().collection('notes').get() 해당 테이블을 get() read 하면
          // snapshot 이라는 결과를 return 시키므로 변수명을 snapshot로 해야함.
          // snapshot을 담는 변수 v.data()를 하면 store에 저장된 컬럼들을 가져온다.
          const snapshot = await this.$firebase.firestore().collection('notes').get()
          snapshot.forEach(v =>{
            const { title, content } = v.data()
            // 가져온 데이터들을 push를 이용해 카드들을 그려줌.
            this.items.push({
              title, content, id: v.id
            })
          })
          console.log(snapshot)
        },
        // id를 이용한 데이터 수정
        async put (id) {
          const r = await this.$firebase.firestore().collection('notes').doc(id).set({ 
            title: this.title,
            content: this.content
           })
           await this.get()
           console.log(r)
        },
        // id를 이용한 데이터 삭제
        async del (id){
          const r = await this.$firebase.firestore().collection('notes').doc(id).delete()
          await this.get()
          console.log(r)
        }
    }
  }
</script>